export default __webpack_public_path__ + "static/media/cute_duckies.70a6e95a.png";